import { requestGet } from '../request';
import apiPath from './apiPath';
const api = {
  GetSalesSummaryCount(payload) {
    return requestGet(apiPath.SALES_SUMMARY_COUNT.path, payload);
  },
  GetSalesMenu(payload) {
    return requestGet(apiPath.SALES_SUMMARY_MENUS.path, payload);
  },
  ExportSalesReport(payload) {
    return requestGet(apiPath.SALES_SUMMARY_EXPORT.path, payload);
  }
};

export default api;
